import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { poetryPieces } from '../data/poetry';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FloatingIcons from '../components/FloatingIcons';

function Poetry() {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <FloatingIcons />
      <Header />
      <section className="blog-posts-section poetry-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="blog-posts-title">कलम की जुबां</h1>
            <p className="blog-posts-subtitle">Poetry and thoughts in Hindi</p>
          </motion.div>

          <div className="blog-posts-grid">
            {poetryPieces.map((poem, index) => {
              const formattedDate = poem.date === 'TBD' ? 'Date TBD' : new Date(poem.date).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              });

              return (
                <motion.div
                  key={poem.id}
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  whileHover={{ y: -10, scale: 1.02 }}
                >
                  <Link to={`/poetry/${poem.id}`} className="blog-post-card">
                    {poem.logo && (
                      <div className="blog-post-logo">
                        <img src={poem.logo} alt={poem.title} />
                      </div>
                    )}
                    <div className="blog-post-content">
                      <h3 className="blog-post-title">{poem.title}</h3>
                      <div className="blog-post-meta">
                        <span className="blog-post-date">{formattedDate}</span>
                        {poem.tags && poem.tags.length > 0 && (
                          <div className="blog-post-tags">
                            {poem.tags.slice(0, 2).map((tag) => (
                              <span key={tag} className="blog-tag-small">{tag}</span>
                            ))}
                          </div>
                        )}
                      </div>
                      {poem.excerpt && (
                        <p className="blog-post-excerpt">{poem.excerpt}</p>
                      )}
                    </div>
                  </Link>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Poetry;

